var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboarding4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 318,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.5 303.5l6.48-65.152 2.806-28.206 2.004-20.157L145.871 8.2",
    stroke: "#E1ECF8",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 303.5l17.222-173.15M62.227 286.133l3.875-38.959 9.67-97.224M39.942 218.623l7.12-71.591M160.503 182.817l7.112-71.505M148.5 303.5l5.05-50.777M181.208 286.331l2.322-23.353a4.997 4.997 0 011.413-3.013l7.452-7.57a7.001 7.001 0 001.981-4.259l7.407-79.175a6.009 6.009 0 00-1.191-4.182l-5.264-6.949a4.999 4.999 0 01-.99-3.514L208.871 8.2M218.524 212.776l7.419-74.597",
    stroke: "#E1ECF8",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.339 96.243l66.253 4 26.591 1.606M86.987 117.531l134.943 8.148M91.809 141.003l117.212 7.077M22.5 160l219.9 13.277M28.54 184.546l202.671 12.236M55.13 209.332l50.914 3.074M177.885 216.744l58.515 3.533M53.664 234.425l148.817 8.985M78.308 262.154l120.354 7.267",
    stroke: "#E1ECF8",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.518 188a1.479 1.479 0 01-1.482-1.477v-11.809c0-.816.664-1.477 1.482-1.477s1.481.661 1.481 1.477v11.809c0 .816-.663 1.477-1.481 1.477z",
    fill: "#5F6E9B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.094 188a1.479 1.479 0 01-1.481-1.477v-11.809c0-.816.663-1.477 1.48-1.477.82 0 1.482.661 1.482 1.477v11.809c0 .816-.663 1.477-1.481 1.477z",
    fill: "#414B82"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.188 165.908a1.237 1.237 0 011.746.02 1.229 1.229 0 01-.021 1.741l-3.74 3.643c-.774.754-2.092.216-2.097-.875l-.023-4.61a.453.453 0 00-.453-.449h-.025v9.336h-6.539v-2.685l-2.061-.493a1.232 1.232 0 01-.947-1.197v-4.524c.009-1.598 1.33-2.899 2.945-2.899H74.6a2.924 2.924 0 012.922 2.899l.008 1.707 1.658-1.614zm-11.69-.083v3.543l.538.129v-4.119h-.063c-.256 0-.473.205-.475.447z",
    fill: "#FFB69E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.522 165.815a2.924 2.924 0 00-2.922-2.899h-2.126l.001.018c.03.645-.571 1.195-1.198 1.195-.671 0-1.169-.548-1.198-1.195v-.018h-2.106c-1.616 0-2.936 1.301-2.945 2.899v1.418h2.47v-1.408c.002-.242.219-.447.475-.447h.063v9.336h6.54v-9.336h.024c.248 0 .451.202.453.449l.006 1.406h2.469l-.006-1.418z",
    fill: "#64AFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.276 162.103a2.556 2.556 0 002.559-2.552A2.555 2.555 0 0071.276 157a2.555 2.555 0 00-2.558 2.551 2.555 2.555 0 002.558 2.552z",
    fill: "#FFB69E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.112 167.542a.596.596 0 01-.537-.861l1.418-2.882a.598.598 0 111.075.527l-1.418 2.881a.599.599 0 01-.538.335z",
    fill: "#6C9BAA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.63 172.615a1.23 1.23 0 00.287-2.428l-2.88-.69v2.532l2.305.552c.097.023.194.034.289.034z",
    fill: "#FFB69E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M168.517 137.607a1.53 1.53 0 01-1.53-1.531v-13.081a1.53 1.53 0 113.061 0v13.081c0 .845-.685 1.531-1.531 1.531z",
    fill: "#42464A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M164.823 137.607a1.531 1.531 0 01-1.531-1.531v-13.081a1.53 1.53 0 013.061 0v13.081a1.53 1.53 0 01-1.53 1.531z",
    fill: "#50555A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M176.346 103.679a1.275 1.275 0 00-1.625.781l-1.772 5.056-3.947 2.105h-5.769c-1.682 0-3.057 1.347-3.065 3.009V124a1.275 1.275 0 002.55 0v-9.363c.002-.244.247-.465.515-.465h.059v9.671h6.756v-9.889l4.54-2.422c.282-.15.497-.401.603-.703l1.937-5.525a1.275 1.275 0 00-.782-1.625z",
    fill: "#FFB69E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M171.787 110.135l-2.785 1.486h-.967c.028.718-.64 1.329-1.337 1.329-.746 0-1.299-.608-1.335-1.329h-2.13c-1.682 0-3.057 1.347-3.065 3.009v2.748h2.55v-2.741c.002-.244.247-.465.515-.465h.059v9.671h6.756v-9.889l3.005-1.603-1.266-2.216z",
    fill: "#414B82"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M166.67 110.778a2.643 2.643 0 10.001-5.287 2.643 2.643 0 00-.001 5.287z",
    fill: "#FFB69E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M116.5 303.5l5.848-59.721a5 5 0 00-4.665-5.477l-18.398-1.147a5 5 0 01-4.663-5.498l3.884-38.044a5 5 0 015.229-4.486l19.263.984a5 5 0 005.23-4.499l7.889-79.294c.519-5.42 4.954-8.996 10.383-8.586l41.694 2.819c6.459.437 12.101-4.33 12.749-10.771l7.928-78.785",
    stroke: "#2E8DDE",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M71.68 191.735l-1.387 13.196a5 5 0 004.655 5.512l16.522 1.053M94.094 141.003l33.148 2.152M141.279 144.058l17.837 1.092a5 5 0 005.317-4.464l.328-1.686",
    stroke: "#2E8DDE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0 6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.047 14.84a6.5 6.5 0 100-13 6.5 6.5 0 000 13zM96.5 215a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM132.5 146a3.5 3.5 0 100-7 3.5 3.5 0 000 7z",
    fill: "#2E8DDE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.426 131.512a1.313 1.313 0 01.204 1.884l-3.739 4.45a1.33 1.33 0 01-1.568.356v2.641h-6.975v-9.889l-3.6 1.203c-1.148.39-2.173-.844-1.569-1.888l3.595-6.204a1.323 1.323 0 011.798-.481 1.3 1.3 0 01.485 1.784l-1.847 3.189.447-.118c.213-.056.439-.084.66-.084h7.006c.676 0 1.336.249 1.884.671l3.219 2.486zm-5.103-.535v4.621l2.39-2.843-2.136-1.649a.616.616 0 00-.254-.129z",
    fill: "#FFB69E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M90.928 154.946c-.873 0-1.58-.702-1.58-1.568v-12.535c0-.867.707-1.569 1.58-1.569.873 0 1.58.703 1.58 1.569v12.535c0 .866-.707 1.568-1.58 1.568z",
    fill: "#748488"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M94.743 154.946c-.873 0-1.58-.702-1.58-1.568v-12.535c0-.867.707-1.569 1.58-1.569.873 0 1.58.703 1.58 1.569v12.535c0 .866-.707 1.568-1.58 1.568z",
    fill: "#55696E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M92.85 127.455a2.719 2.719 0 002.729-2.708 2.72 2.72 0 00-2.73-2.709 2.72 2.72 0 00-2.73 2.709 2.719 2.719 0 002.73 2.708z",
    fill: "#FFB69E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M98.207 129.026c-.548-.422-1.208-.671-1.884-.671H94.445c.035.867-.777 1.591-1.625 1.591-.908 0-1.581-.721-1.623-1.591h-1.883c-.222 0-.443.028-.658.085l-.446.117-1.935 3.424 3.072-1.027v9.889h6.976v-9.866a.616.616 0 01.254.129l1.603 1.238 1.661-2.055-1.634-1.263z",
    fill: "#8C66AB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M110.309 281.692a5.332 5.332 0 015.778-4.848l5.313.465a5.332 5.332 0 014.848 5.777l-.589 6.732s1.531.039 1.48.622c-.051.582-1.563.328-1.563.328l-1.953 22.315a3.555 3.555 0 01-3.851 3.232l-8.856-.775a3.555 3.555 0 01-3.232-3.852l1.957-22.365s-1.556-.015-1.509-.546c.046-.531 1.587-.347 1.587-.347l.59-6.738z",
    fill: "#000"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M110.807 287.819s2.567-4.13 7.321-3.714c4.755.416 6.565 4.929 6.565 4.929l-.378 4.321s-3.431-.768-6.902-1.071c-3.472-.304-6.984-.144-6.984-.144l.378-4.321z",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M111.284 293.488l-1.614 18.452M123.239 294.534l-1.615 18.452",
    stroke: "#fff",
    strokeWidth: 0.597,
    strokeLinecap: "square"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M112.665 277.708l-.509 5.819-.996-.088.417-4.768s.316-.34.504-.507c.187-.168.584-.456.584-.456zM110.163 283.352l-.421 4.822-.997-.087.346-3.952s.311-.277.496-.413c.185-.137.576-.37.576-.37zM124.619 278.76l-.509 5.812.996.088.418-4.774-.417-.631-.488-.495z",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M111.271 313.713l8.453.74 1.393-.232-1.545.639-8.212-.718-1.463-.902 1.374.473z",
    fill: "#BA0000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#onboarding4_svg__filter0_f_0_7054)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M86.246 155.438h13v2.785h-13z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#onboarding4_svg__filter1_f_0_7054)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M160 138.5h13v2.785h-13z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#onboarding4_svg__filter2_f_0_7054)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M65 188h13v2.785H65z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "onboarding4_svg__filter0_f_0_7054",
    x: 83.527,
    y: 152.719,
    width: 18.437,
    height: 8.222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.359,
    result: "effect1_foregroundBlur_0_7054"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "onboarding4_svg__filter1_f_0_7054",
    x: 157.282,
    y: 135.782,
    width: 18.437,
    height: 8.222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.359,
    result: "effect1_foregroundBlur_0_7054"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "onboarding4_svg__filter2_f_0_7054",
    x: 62.282,
    y: 185.282,
    width: 18.437,
    height: 8.222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.359,
    result: "effect1_foregroundBlur_0_7054"
  })))));
}
export default SvgOnboarding4;